module.exports = __webpack_public_path__ + "img/before-mars.fbe94949.png";